import axios from "axios";

export default {
  namespaced: true,
  state: {
    salestargets: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    salestargetsMessage: ''
  },
  mutations: {
    RECEIVED_SALESTARGETS(state, payload) {
      state.salestargets = payload;
      state.isReceiving = false;
    },
    RECEIVING_SALESTARGETS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_SALESTARGET(state) {
      state.isReceiving = true;
    },
    RECEIVED_SALESTARGET(state, payload) {
      state = Object.assign(state, {
        salestargets: [...state.salestargets, payload],
        isReceiving: false,
      })
    },

    UPDATED_SALESTARGETS(state, payload) {
      console.log(state.salestargets);
      console.log(payload);
      let index = state.salestargets.findIndex(salestarget => salestarget._id === payload._id);
      state = Object.assign(state, {
        salestargets: state.salestargets.map((salestarget, i) => {
          if (i === index) {
            return Object.assign({}, salestarget, payload);
          }
          return salestarget;
        }),
        isUpdating: false,
        salestargetsMessage: 'SalesTragets has been updating!',
      })
    },
    UPDATING_SALESTARGETS(state) {
      state.isUpdating = true;
    },
    DELETED_SALESTARGETS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.salestargets.findIndex(salestarget => salestarget._id === payload._id);
      console.log(indexToDelete);
      let salestargets = [...state.salestargets];
      salestargets.splice(indexToDelete, 1);
      state = Object.assign(state, {
        salestargets: [...salestargets],
        isDeleting: false,
        idToDelete: null,
        salestargetsMessage: 'SalesTraget has been Deleted!',
      });
    },
    DELETING_SALESTARGETS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async runTargetRequest({dispatch}, payload) {
      dispatch("receivingSalesTragets");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/run/target';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      return axios(post);
    },
    async insertSalesTragetRequest({dispatch}, payload) {
      dispatch("receivingSalesTragets");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/salestarget';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {dispatch("receiveSalesTraget", response.data);})
      .catch((error) => {this.alertmessage = error;});	
    },
    async insertSTTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/sttransaction/" + payload.salestargetid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        console.log(response.data);
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    deleteSalesTragetRequest({dispatch}, payload) {
      dispatch("deletingSalesTraget", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/salestarget/' + payload._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      let del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(response=>{
        dispatch("deleteSalesTraget", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteSTTransactionRequest({dispatch}, id) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/sttransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    getSalesTragetsRequest({dispatch}) {
      dispatch("receivingSalesTragets");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/salestargets';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        console.log(res.data)
        dispatch("receiveSalesTragets", res.data);
      })
    },
    async updateSalesTragetRequest({dispatch}, payload) {
      dispatch("updatingSalesTraget");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/salestarget/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers,data: payload})
      .then((response)=> {
        dispatch("updateSalesTraget", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateSTTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        var id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/update/sttransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "put", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    receiveSalesTragets({commit}, payload) {
      commit("RECEIVED_SALESTARGETS", payload)
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivingSalesTragets({commit}) {
      commit("RECEIVING_SALESTARGETS")
    },
    receiveSalesTraget({commit}, payload) {
      commit("RECEIVED_SALESTARGET", payload)
    },
    receivingSalesTraget({commit}) {
      commit("RECEIVING_SALESTARGETS")
    },
    updateSalesTraget({commit}, payload) {
      commit("UPDATED_SALESTARGETS", payload)
    },
    updatingSalesTraget({commit}) {
      commit("UPDATING_SALESTARGETS")
    },
    deleteSalesTraget({commit}, payload) {
      commit("DELETED_SALESTARGETS", payload)
    },
    deletingSalesTraget({commit}, payload) {
      commit("DELETING_SALESTARGETS", payload)
    }
  },
};
